import Entity from './entity'

export default class Category extends Entity<number>{
    orderNo:number;
    code:string;
    name:string;
    parentId:number;
    clientCode:string;
    parentCode :string;
    clientName:string;
}